
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * React-Admin List component for: Role Resource
 */

import * as RA from 'react-admin';


const postFilters = [
    <RA.TextInput source="search" label="Search" alwaysOn />
];
const RoleList = () => (
    <RA.List filters={postFilters}> 
        <RA.Datagrid rowClick="edit">
            <RA.TextField source="name" />

            <RA.TextField source="id" />

        </RA.Datagrid>
    </RA.List>
);

export default RoleList;

